<footer *ngIf="showFooter">
    <div class="footer fixed-bottom" [ngStyle]="{'background-color' : footerColor}">
        <div [innerHTML]= "footerText | sanitizeHtml">
        </div>
    </div>
</footer>
